import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { error, success, warning } from "../../Components/custom-toast/CustomToast";
import { CustomCounterCustomer } from "../../Components/custom-counter/CustomCounterCustomer";
import * as CustomerService from "../../Services/customer-service";
import '../../Assets/Styles/Customer/otpinput.css';
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../Layouts/useWindowDimension";
import { toast } from "react-toastify";

const OtpResetPassword = ({ length, objectDto, setObjectDto, setLoading, setPoIdNumber }) => {
    const [otp, setOtp] = useState(new Array(length).fill(""));
    const [counter, setCounter] = useState(localStorage.getItem('countOtp') !== null ? JSON.parse(localStorage.getItem("countOtp")) : JSON.parse(localStorage.getItem("aaa")) != null ? JSON.parse(localStorage.getItem("aaa")).minute * 60 : 120);
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const [visible, setVisible] = useState(true);
    const [countFail, setCountFail] = useState(localStorage.getItem('countWrongOtp') !== null ? JSON.parse(localStorage.getItem('countWrongOtp')) : 0)
    useEffect(() => {
    }, [i18n]);
    useEffect(() => {
        const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        localStorage.setItem("countOtp", JSON.stringify(counter));
        if (counter === 0) {
            setVisible(false);
            toast.dismiss();
            warning(t("errorexpiredotp"));
        }
        return () => clearInterval(timer);
    }, [counter]);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, []);

    const handleChange = async (index, e) => {
        const value = e.target.value;
        if (isNaN(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value.substring(value.length - 1);
        setOtp(newOtp);

        // count submit
        const combinedOtp = newOtp.join("");
        if (combinedOtp.length === length) {
            setLoading(true);
            //riu
            const verify = await CustomerService.verifyOtpResetPassword(objectDto, setObjectDto, combinedOtp, setLoading);
            if (verify === false) {
                setOtp(['', '', '', '', '', '']);
                inputRefs.current[0].focus();
                if (countFail + 1 < 5) {
                    setCountFail(countFail + 1);
                    localStorage.setItem("countWrongOtp", JSON.stringify(countFail));
                } else {
                    localStorage.removeItem("countWrongOtp");
                    localStorage.removeItem("countOtp");
                    CustomerService.LogOut(setObjectDto);
                    error(t("errorcountotp"));
                    setPoIdNumber("");
                }
            } else {
                localStorage.removeItem("countWrongOtp");
                localStorage.removeItem("countOtp");
            }

        }
        if (value && index < length - 1 &&
            inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleClick = (index) => {
        inputRefs.current[index].setSelectionRange(1, 1);
        if (index > 0 && !otp[index - 1]) {
            inputRefs.current[otp.indexOf("")].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0 && inputRefs.current[index - 1]) {
            inputRefs.current[index - 1].focus();
        }
    };
    const colorDisable = "#696969";
    const colorEnable = "#DFB246";

    const styled_btn_relogin = width < 430 ? {
        textAlign: "center", borderRadius: "5px", fontWeight: 300, backgroundColor: colorEnable, color: "white",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }, margin: "1%",
        "&.MuiButton-root": { padding: "2px 8px" }
    } : width < 1183 ? {
        textAlign: "center", borderRadius: "5px", fontWeight: 300, backgroundColor: colorEnable, color: "white",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }, margin: "1%",
        "&.MuiButton-root": { padding: "4px 8px" }
    } : {
        textAlign: "center", borderRadius: "5px", fontWeight: 300, backgroundColor: colorEnable, color: "white",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }, margin: "1%",
    }

    const styled_btn_reotp = width < 430 ? {
        textAlign: "center", borderRadius: "5px", fontWeight: 300, backgroundColor: colorEnable, color: "white",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }, margin: "1%",
        "&.MuiButton-root": { padding: "2px 8px" }, "&.Mui-disabled": { backgroundColor: colorDisable, color: "white" }
    } : width < 1183 ? {
        textAlign: "center", borderRadius: "5px", fontWeight: 300, backgroundColor: colorEnable, color: "white",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }, margin: "1%",
        "&.MuiButton-root": { padding: "4px 8px" }, "&.Mui-disabled": { backgroundColor: colorDisable, color: "white" }
    } : {
        textAlign: "center", borderRadius: "5px", fontWeight: 300, backgroundColor: colorEnable, color: "white",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }, margin: "1%", "&.Mui-disabled": { backgroundColor: colorDisable, color: "white" }
    }
    return (
        <section className="container-otp">
            <p className="otp-font th-policy-customer">{objectDto.otp}</p>
            <div className="otp-font th-policy-customer">
                <label style={{ display: objectDto.otp !== undefined && objectDto.otp !== '' ? "block" : "none" }} id="countdown" >
                    <CustomCounterCustomer time={counter} />
                </label>
            </div>
            <div>
                {visible ? otp.map((value, index) => {
                    return (
                        <input key={index} inputMode="numeric" type="text" ref={(input) => (inputRefs.current[index] = input)} value={value} onChange={(e) => handleChange(index, e)}
                            onClick={() => handleClick(index)} onKeyDown={(e) => handleKeyDown(index, e)} className="otp-input description-large-customer" />
                    );
                }) : ""}
            </div>
            <div className="col-otp-all">
                <Button variant="contained" disabled={visible} component="label" onClick={() => {
                    setOtp(['', '', '', '', '', '']);
                    toast.dismiss();
                    success(t("sendotpsuccess"));
                    setCounter(120);
                    localStorage.setItem('countOtp', JSON.stringify(120));
                    setVisible(true);
                    inputRefs.current[0].focus();
                    localStorage.removeItem("countWrongOtp");
                }} sx={styled_btn_reotp}>
                    <span className="btn-font">{t("resendotp")}</span>
                </Button>
                <Button variant="contained" component="label" onClick={() => { CustomerService.LogOut(setObjectDto); setLogin({ 'username': "", 'phone': '' }); localStorage.removeItem("countOtp"); localStorage.removeItem("countWrongOtp"); toast.dismiss(); }} sx={styled_btn_relogin}>
                    <span className="btn-font">{counter === 0 ? "Đăng ký lại" : "Nhập lại"}</span>
                </Button>
            </div>
        </section>
    );
};
export default OtpResetPassword;